import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { ECarriersList, IClient } from 'types/Carrier';

export const CARRIER_DATE_OFFSET: Record<ECarriersList, number> = {
	[ECarriersList.FASCHIM_CARRIER]: 0,
	[ECarriersList.CHUBB_CARRIER]: 0,
	[ECarriersList.DECARE]: 90,
	[ECarriersList.DEFAULT_CARRIER]: 45,
};

export const useCheckEligibility = () => {
	const { dateOfService } = useSelector((store: RootState) => store.form);

	const showDateInfoLabel = useCallback((client?: IClient) => {
		if (!client) {
			return false;
		}

		switch (client?.carrier.customLayout) {
			case ECarriersList.FASCHIM_CARRIER:
			case ECarriersList.CHUBB_CARRIER:
				return false;
			default:
				return true;
		}
	}, []);

	const checkEligibilityForceDate = useCallback((client?: IClient) => {
		switch (client?.carrier.customLayout) {
			case ECarriersList.FASCHIM_CARRIER:
				return true;
			default:
				return false;
		}
	}, []);

	const checkEligibilityValidDate = (client?: IClient) => {
		switch (client?.carrier.customLayout) {
			case ECarriersList.FASCHIM_CARRIER:
			case ECarriersList.CHUBB_CARRIER:
				return true;
			case ECarriersList.DECARE:
				if (
					dateOfService &&
					dayjs(dateOfService).isBefore(
						dayjs().subtract(CARRIER_DATE_OFFSET[ECarriersList.DECARE] + 1, 'day'),
					) // enable the 45th day to be selected
				) {
					return false;
				}

				return true;
			default:
				if (
					dateOfService &&
					dayjs(dateOfService).isBefore(
						dayjs().subtract(
							CARRIER_DATE_OFFSET[ECarriersList.DEFAULT_CARRIER] + 1,
							'day',
						),
					) // enable the 45th day to be selected
				) {
					return false;
				}

				return true;
		}
	};

	const validationFiscalCode = (client: IClient, value: string) => {
		switch (client.carrier.customLayout) {
			case ECarriersList.FASCHIM_CARRIER:
				return value.length === 16;
			case ECarriersList.DECARE:
				return value.length > 1;
			default:
				return true;
		}
	};

	const searchMemberCarrierCustomization = (
		client: IClient,
		setFilter: (filterType: string | null) => void,
	) => {
		switch (client.carrier.customLayout) {
			case ECarriersList.FASCHIM_CARRIER:
				return setFilter('inputByFiscalCode');
			default:
				return setFilter(null);
		}
	};

	return {
		showDateInfoLabel,
		checkEligibilityValidDate,
		checkEligibilityForceDate,
		validationFiscalCode,
		searchMemberCarrierCustomization,
	};
};
